import React from 'react';
import { cn } from '../../lib/utils';

export type EditorialButtonVariant =
  'accent' | 'outline' | 'secondary' | 'ghost';

export type EditorialButtonSize = 'sm' | 'md' | 'lg';

export function editorialButtonClasses(
  variant: EditorialButtonVariant = 'accent',
  size: EditorialButtonSize = 'md'
): string {
  const variants: Record<EditorialButtonVariant, string> = {
    accent:
      'bg-brand-accent text-white hover:bg-brand-accent/90 shadow-md border border-brand-accent',
    outline:
      'bg-transparent border border-white/30 text-white hover:bg-white/10',
    secondary:
      'bg-white text-brand-primary hover:bg-gray-50 border border-brand-primary/10',
    ghost: 'bg-transparent text-brand-primary hover:bg-gray-100',
  };

  const sizes: Record<EditorialButtonSize, string> = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg font-medium',
  };

  return cn(
    'rounded-none transition-all duration-200 inline-flex items-center justify-center gap-2 cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-accent',
    variants[variant],
    sizes[size]
  );
}

export function MarketingButton({
  variant = 'accent',
  size = 'md',
  className,
  children,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: EditorialButtonVariant;
  size?: EditorialButtonSize;
}): React.JSX.Element {
  return (
    <button
      className={cn(editorialButtonClasses(variant, size), className)}
      {...props}
    >
      {children}
    </button>
  );
}
